// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/selectArrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  color: #000;
  font-size: 16px;
  line-height: 19px;
  margin-top: 1.8rem;
  font-family: "Monsterrat 600";
  font-weight: 600;
}

.form-control {
  display: flex;
  align-items: center;
  position: relative;
}

.react-datepicker-popper {
  z-index: 2 !important;
}

.base-input {
  background: #fff;
  border-radius: 8px 0 0 8px;
  padding: 11px;
  height: 38px;
  width: 136px;
  color: #3e3e3e;
  font-size: 13px;
  border: 0.8px solid transparent;
  transition: border 500ms;
}
.base-input::placeholder {
  color: #858181;
  font-size: 12px;
}
.base-input:focus, .base-input:active {
  border-color: #1c1c84 !important;
}
.base-input.notActive {
  border-color: red !important;
}
.base-input.notActive:focus, .base-input.notActive:active {
  border-color: red !important;
}

.react-tel-input .form-control.notActive {
  border-color: red !important;
}
.react-tel-input .form-control.notActive:focus, .react-tel-input .form-control.notActive:active {
  border-color: red !important;
}

.base-icon {
  height: 38px;
  width: 40px;
  border: 0.5px solid #7e7a7a;
  background: #f6f6f6;
  border-radius: 0 8px 8px 0;
  transition: background 500ms;
  cursor: pointer;
}
.base-icon:hover {
  background: #e2e2e2;
}
.base-icon svg {
  margin: auto;
  font-family: "Monsterrat 300";
}

.block {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 4px;
  position: relative;
}
.block label {
  display: block;
  font-size: 13px;
  color: #000;
}
.block label .label-price {
  color: #8b8b8b !important;
  font-size: 10px !important;
}

.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper,
.css-pwxzbm {
  max-height: 500px !important;
}
.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper .css-i4bv87-MuiSvgIcon-root,
.css-pwxzbm .css-i4bv87-MuiSvgIcon-root {
  fill: #2e8b57;
}
.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper .item-text,
.css-pwxzbm .item-text {
  padding-left: 10px;
  text-wrap: wrap !important;
}
.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper .item-text span,
.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper .item-text .css-yb0lig,
.css-pwxzbm .item-text span,
.css-pwxzbm .item-text .css-yb0lig {
  font-size: 12px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  font-family: "Monsterrat 400" !important;
}
.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root,
.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper .css-1km1ehz,
.css-pwxzbm .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root,
.css-pwxzbm .css-1km1ehz {
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.031372549) !important;
}

.css-10hburv-MuiTypography-root {
  font-family: "Monsterrat 400" !important;
}

.input {
  background: #f6f6f6;
  font-size: 13px;
  color: #000;
  padding: 11px;
  border-radius: 10px;
  border: 1px solid #d9d0d0;
  transition: border 500ms;
}
.input::placeholder {
  font-size: 12px;
  color: #c8c8c8;
}
.input.input-error {
  border: 1px solid #f14b4b;
}
.input:focus, .input:active {
  border-color: #1c1c84;
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 5px;
  padding: 8px 12px;
  transition: background 500ms;
  cursor: pointer;
}
.button.button-success {
  background: #2e8b57;
  color: #fff;
  border-radius: 5px;
  font-size: 13px;
  font-family: "Monsterrat 500";
}
.button.button-success:hover {
  background: #11a17b;
}
.button.button-primary {
  background: #ff6600;
  color: #fff;
  box-shadow: 0px 10px 15px 0px #ff6600 0d;
  border-radius: 10px;
  font-size: 13px;
  font-family: "Monsterrat 500";
  transition: background 500ms, box-shadow 500mx;
}
.button.button-primary:hover {
  background: #c95000;
  box-shadow: none;
}
.button.button-slate {
  color: #000;
  background: #efefef;
  border: 1px solid #d9d0d0;
  font-size: 13px;
  border-radius: 10px;
  transition: background 500ms;
}
.button.button-slate:hover {
  background: #d9d0d0;
}

.select {
  border: 1px solid #d9d0d0 !important;
  background: #f6f6f6 !important;
  font-size: 13px !important;
  color: #000 !important;
  border-radius: 10px !important;
  font-family: "Monsterrat 400" !important;
  transition: border 500ms;
}
.select fieldset {
  border: none !important;
}
.select.error {
  border: 1px solid #3e3e3e !important;
}
.select.select-green .css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input,
.select.select-green .css-182didf.css-182didf.css-182didf {
  color: #00bf63;
  font-family: "Monsterrat 500" !important;
}
.select.chip {
  min-height: 37.9px !important;
}
.select.chip .css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input,
.select.chip .css-182didf {
  padding: 2px !important;
}
.select.chip .chip-item > div {
  border-radius: 10px !important;
  background: rgba(0, 173, 239, 0.1) !important;
}
.select.chip .chip-item > div span {
  color: #616362 !important;
  font-size: 13px !important;
}

.personal-account-item {
  font-size: 13px !important;
  font-family: "Monsterrat 600" !important;
  box-shadow: none !important;
}

.table {
  min-width: max-content;
  width: 100%;
  background: #fff;
  border-radius: 15px;
}
.table tbody tr:not(:last-child) {
  border-bottom: 1px solid #eeeded;
}
.table .strong-tr td {
  font-family: "Monsterrat 600";
}
.table th {
  padding: 1rem 8px;
  max-width: 225px;
  min-width: 88px;
  font-size: 13px;
  text-align: left;
  font-weight: 700;
  position: relative;
  color: #000;
  z-index: 1;
}
.table th:first-child {
  padding-left: 2rem;
}
.table td {
  padding: 0.4rem 8px;
  font-size: 13px;
  font-weight: 600;
  color: rgb(37, 37, 37);
}
.table td:first-child {
  padding-left: 2rem;
}
.table td.bg-danger {
  background: #f42020 !important;
  color: #fff !important;
  font-family: "Monsterrat 500" !important;
  font-size: 15px !important;
}
.table td.bg-warning {
  background: #ffb800 !important;
  color: #fff !important;
  font-family: "Monsterrat 500" !important;
  font-size: 15px !important;
}
.table.table-bordered thead tr {
  position: relative;
  border-bottom: 1.5px solid #eeeded;
  padding: 4px;
}
.table.table-bordered thead tr::after {
  content: "";
  border-radius: 15px;
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  background: #eeeded;
}
.table.table-custom thead tr {
  border-bottom: 1.5px solid #8b8b8b;
}
.table.table-custom tr th {
  position: relative;
  padding: 1.25rem 12px;
}
.table.table-custom tr th:not(:last-child)::before {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  height: 30px;
  width: 1px;
  background: #8b8b8b;
}

.main-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
  margin-top: auto;
}

.modal {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 605px;
  max-height: 90%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  overflow-y: auto;
}
.modal.transaction-modal {
  width: 90%;
  height: 90%;
}
.modal::-webkit-scrollbar {
  width: 8px;
}
.modal::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 8px;
}
@media (max-width: 767px) {
  .modal {
    width: 98%;
  }
}
.modal .modal-body {
  padding: 3.2rem;
  position: relative;
  overflow-y: auto;
}
@media (max-width: 767px) {
  .modal .modal-body {
    padding: 1.2rem 12px;
  }
}
.modal .modal-body .modal-loading {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ff6600;
  border-radius: 10px 10px 0 0;
  padding: 16px 20px;
}
.modal-header .header-title {
  font-family: "Monsterrat 500";
  color: #fff;
}
.modal-header button {
  background: transparent;
  transition: background 500ms;
}
.modal-header button:hover {
  background: rgba(255, 255, 255, 0.3);
}

.modal-info {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  gap: 12px;
}
.modal-info .info-button {
  display: flex;
  align-items: center;
  column-gap: 5px;
  font-size: 13px;
  border: 1px solid #00bf63;
  border-radius: 5px;
  padding: 8px 16px;
  transition: background 500ms, color 500ms;
}
.modal-info .info-button:hover {
  background: #00bf63;
  color: #fff;
}

.modal-block {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  margin-bottom: 1rem;
}
.modal-block label {
  font-size: 13px;
}

.modal-item {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  padding: 12px 0;
  border-top: 0.5px solid #8b8b8b;
  font-size: 13px;
}
.modal-item strong {
  font-family: "Monsterrat 600" !important;
  font-size: 13px;
  text-align: right;
}

.stepper-indicators {
  display: grid;
  margin-bottom: 1rem;
}
.stepper-indicators .indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0.8rem 0;
}
.stepper-indicators .indicator::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: #c8c8c8;
  transform: translateY(-50%);
}
.stepper-indicators .indicator.active::before {
  background: #2e8b57;
}
.stepper-indicators .indicator.active .indicator-count {
  background: #2e8b57;
}
.stepper-indicators .indicator.active svg {
  display: block;
}
.stepper-indicators .indicator.active .indicator-title {
  color: #3e3e3e;
}
.stepper-indicators .indicator.current::before {
  background: #ff6600;
}
.stepper-indicators .indicator.current .indicator-count {
  background: #ff6600;
}
.stepper-indicators .indicator svg {
  display: none;
}
.stepper-indicators .indicator .indicator-count {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #d9d9d9;
  color: #fff;
  font-size: 32px;
  z-index: 1;
}
@media (max-width: 767px) {
  .stepper-indicators .indicator .indicator-count {
    width: 40px;
    height: 40px;
    font-size: 24px;
  }
}
.stepper-indicators .indicator-title {
  position: absolute;
  top: 100%;
  color: #858181;
  font-size: 14px;
}
@media (max-width: 767px) {
  .stepper-indicators .indicator-title {
    font-size: 12px;
    text-align: center;
  }
}

.select-arrow {
  overflow: hidden;
  overflow: -moz-hidden-unscrollable;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right white;
  background-size: contain;
  display: inline-block;
  position: relative;
  -webkit-appearance: none;
  padding-right: 3rem;
}

.MuiTooltip-tooltip {
  font-size: 16px !important;
}

.MuiCircularProgress-circle {
  color: #1c1c84 !important;
}

.courier-select .MuiInputBase-input {
  font-family: "Monsterrat 400" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.video-player::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.4705882353);
}

@media (min-width: 1400px) and (max-width: 1600px) {
  .responsive-block {
    width: 200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_components.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,wBAAA;AACF;AAAE;EACE,cAAA;EACA,eAAA;AAEJ;AAAE;EAEE,gCAAA;AACJ;AACE;EACE,4BAAA;AACJ;AAAI;EAEE,4BAAA;AACN;;AAIE;EACE,4BAAA;AADJ;AAEI;EAEE,4BAAA;AADN;;AAKA;EACE,YAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,eAAA;AAFF;AAGE;EACE,mBAAA;AADJ;AAGE;EACE,YAAA;EACA,6BAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,QAAA;EACA,kBAAA;AAFF;AAGE;EACE,cAAA;EACA,eAAA;EACA,WAAA;AADJ;AAEI;EACE,yBAAA;EACA,0BAAA;AAAN;;AAIA;;EAEE,4BAAA;AADF;AAEE;;EACE,aAAA;AACJ;AACE;;EACE,kBAAA;EACA,0BAAA;AAEJ;AADI;;;;EAEE,0BAAA;EACA,uBAAA;EACA,gBAAA;EACA,wCAAA;AAKN;AAFE;;;;EAEE,iEAAA;AAMJ;;AAHA;EACE,wCAAA;AAMF;;AAJA;EAEE,mBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;AAOF;AANE;EACE,eAAA;EACA,cAAA;AAQJ;AANE;EACE,yBAAA;AAQJ;AANE;EAEE,qBAAA;AAOJ;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;AAMF;AALE;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;AAOJ;AANI;EACE,mBAAA;AAQN;AALE;EACE,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,8CAAA;AAOJ;AANI;EACE,mBAAA;EACA,gBAAA;AAQN;AALE;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,4BAAA;AAOJ;AANI;EACE,mBAAA;AAQN;;AAHA;EACE,oCAAA;EACA,8BAAA;EACA,0BAAA;EACA,sBAAA;EAEA,8BAAA;EACA,wCAAA;EACA,wBAAA;AAKF;AAJE;EACE,uBAAA;AAMJ;AAJE;EACE,oCAAA;AAMJ;AAHI;;EAEE,cAAA;EACA,wCAAA;AAKN;AAFE;EACE,6BAAA;AAIJ;AAHI;;EAEE,uBAAA;AAKN;AAFM;EACE,8BAAA;EACA,6CAAA;AAIR;AAHQ;EACE,yBAAA;EACA,0BAAA;AAKV;;AACA;EACE,0BAAA;EACA,wCAAA;EACA,2BAAA;AAEF;;AACA;EACE,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAEF;AACM;EACE,gCAAA;AACR;AAOI;EACE,6BAAA;AALN;AAQE;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AANJ;AAOI;EACE,kBAAA;AALN;AAQE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AANJ;AAOI;EACE,kBAAA;AALN;AAOI;EACE,8BAAA;EACA,sBAAA;EACA,wCAAA;EACA,0BAAA;AALN;AAOI;EACE,8BAAA;EACA,sBAAA;EACA,wCAAA;EACA,0BAAA;AALN;AAUM;EACE,kBAAA;EACA,kCAAA;EACA,YAAA;AARR;AASQ;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAPV;AA4BM;EACE,kCAAA;AA1BR;AA8BM;EACE,kBAAA;EACA,qBAAA;AA5BR;AA6BQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AA3BV;;AAkCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;AA/BF;;AAkCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AA/BF;AAgCE;EACE,UAAA;EACA,WAAA;AA9BJ;AAgCE;EACE,UAAA;AA9BJ;AAgCE;EACE,0CAAA;EACA,kBAAA;AA9BJ;AAgCE;EArBF;IAsBI,UAAA;EA7BF;AACF;AA8BE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AA5BJ;AA6BI;EAJF;IAKI,oBAAA;EA1BJ;AACF;AA2BI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,oCAAA;EACA,mBAAA;AAzBN;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;AA1BF;AA2BE;EACE,6BAAA;EACA,WAAA;AAzBJ;AA2BE;EACE,uBAAA;EACA,4BAAA;AAzBJ;AA0BI;EACE,oCAAA;AAxBN;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;AAzBF;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yCAAA;AAxBJ;AAyBI;EACE,mBAAA;EACA,WAAA;AAvBN;;AA4BA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AAzBF;AA0BE;EACE,eAAA;AAxBJ;;AA4BA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,+BAAA;EACA,eAAA;AAzBF;AA0BE;EACE,wCAAA;EACA,eAAA;EACA,iBAAA;AAxBJ;;AA4BA;EACE,aAAA;EACA,mBAAA;AAzBF;AA0BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AAxBJ;AAyBI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;AAvBN;AA0BM;EACE,mBAAA;AAxBR;AA0BM;EACE,mBAAA;AAxBR;AA0BM;EACE,cAAA;AAxBR;AA0BM;EACE,cAAA;AAxBR;AA4BM;EACE,mBAAA;AA1BR;AA4BM;EACE,mBAAA;AA1BR;AA6BI;EACE,aAAA;AA3BN;AA6BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AA3BN;AA4BM;EAXF;IAYI,WAAA;IACA,YAAA;IACA,eAAA;EAzBN;AACF;AA4BE;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AA1BJ;AA2BI;EALF;IAMI,eAAA;IACA,kBAAA;EAxBJ;AACF;;AA4BA;EACE,gBAAA;EACA,kCAAA;EACA,yEAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;AAzBF;;AA4BA;EACE,0BAAA;AAzBF;;AA2BA;EACE,yBAAA;AAxBF;;AA0BA;EACE,wCAAA;EACA,2BAAA;EACA,0BAAA;AAvBF;;AA2BE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;AAxBJ;;AA6BE;EADF;IAEI,YAAA;EAzBF;AACF","sourcesContent":[".title {\n  color: #000;\n  font-size: 16px;\n  line-height: 19px;\n  margin-top: 1.8rem;\n  font-family: \"Monsterrat 600\";\n  font-weight: 600;\n}\n\n.form-control {\n  display: flex;\n  align-items: center;\n  position: relative;\n  // z-index: 2;\n}\n.react-datepicker-popper {\n  z-index: 2 !important;\n}\n\n.base-input {\n  background: #fff;\n  border-radius: 8px 0 0 8px;\n  padding: 11px;\n  height: 38px;\n  width: 136px;\n  color: #3e3e3e;\n  font-size: 13px;\n  border: 0.8px solid transparent;\n  transition: border 500ms;\n  &::placeholder {\n    color: #858181;\n    font-size: 12px;\n  }\n  &:focus,\n  &:active {\n    border-color: #1c1c84 !important;\n  }\n  &.notActive {\n    border-color: red !important;\n    &:focus,\n    &:active {\n      border-color: red !important;\n    }\n  }\n}\n.react-tel-input .form-control {\n  &.notActive {\n    border-color: red !important;\n    &:focus,\n    &:active {\n      border-color: red !important;\n    }\n  }\n}\n.base-icon {\n  height: 38px;\n  width: 40px;\n  border: 0.5px solid #7e7a7a;\n  background: #f6f6f6;\n  border-radius: 0 8px 8px 0;\n  transition: background 500ms;\n  cursor: pointer;\n  &:hover {\n    background: #e2e2e2;\n  }\n  svg {\n    margin: auto;\n    font-family: \"Monsterrat 300\";\n  }\n}\n\n.block {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  gap: 4px;\n  position: relative;\n  label {\n    display: block;\n    font-size: 13px;\n    color: #000;\n    .label-price {\n      color: #8b8b8b !important;\n      font-size: 10px !important;\n    }\n  }\n}\n.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper,\n.css-pwxzbm {\n  max-height: 500px !important;\n  .css-i4bv87-MuiSvgIcon-root {\n    fill: #2e8b57;\n  }\n  .item-text {\n    padding-left: 10px;\n    text-wrap: wrap !important;\n    span,\n    .css-yb0lig {\n      font-size: 12px !important;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      font-family: \"Monsterrat 400\" !important;\n    }\n  }\n  .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root,\n  .css-1km1ehz {\n    box-shadow: 0px 4px 8px 0px #00000008 !important;\n  }\n}\n.css-10hburv-MuiTypography-root {\n  font-family: \"Monsterrat 400\" !important;\n}\n.input {\n  border: 1px solid #d9d0d0;\n  background: #f6f6f6;\n  font-size: 13px;\n  color: #000;\n  padding: 11px;\n  border-radius: 10px;\n  border: 1px solid #d9d0d0;\n  transition: border 500ms;\n  &::placeholder {\n    font-size: 12px;\n    color: #c8c8c8;\n  }\n  &.input-error {\n    border: 1px solid #f14b4b;\n  }\n  &:focus,\n  &:active {\n    border-color: #1c1c84;\n  }\n}\n\n.button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  column-gap: 5px;\n  padding: 8px 12px;\n  transition: background 500ms;\n  cursor: pointer;\n  &.button-success {\n    background: #2e8b57;\n    color: #fff;\n    border-radius: 5px;\n    font-size: 13px;\n    font-family: \"Monsterrat 500\";\n    &:hover {\n      background: #11a17b;\n    }\n  }\n  &.button-primary {\n    background: #ff6600;\n    color: #fff;\n    box-shadow: 0px 10px 15px 0px #ff6600 0d;\n    border-radius: 10px;\n    font-size: 13px;\n    font-family: \"Monsterrat 500\";\n    transition: background 500ms, box-shadow 500mx;\n    &:hover {\n      background: #c95000;\n      box-shadow: none;\n    }\n  }\n  &.button-slate {\n    color: #000;\n    background: #efefef;\n    border: 1px solid #d9d0d0;\n    font-size: 13px;\n    border-radius: 10px;\n    transition: background 500ms;\n    &:hover {\n      background: #d9d0d0;\n    }\n  }\n}\n\n.select {\n  border: 1px solid #d9d0d0 !important;\n  background: #f6f6f6 !important;\n  font-size: 13px !important;\n  color: #000 !important;\n  // padding: 11px;\n  border-radius: 10px !important;\n  font-family: \"Monsterrat 400\" !important;\n  transition: border 500ms;\n  fieldset {\n    border: none !important;\n  }\n  &.error {\n    border: 1px solid #3e3e3e !important;\n  }\n  &.select-green {\n    .css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input,\n    .css-182didf.css-182didf.css-182didf {\n      color: #00bf63;\n      font-family: \"Monsterrat 500\" !important;\n    }\n  }\n  &.chip {\n    min-height: 37.9px !important;\n    .css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input,\n    .css-182didf {\n      padding: 2px !important;\n    }\n    .chip-item {\n      > div {\n        border-radius: 10px !important;\n        background: rgba(0, 173, 239, 0.1) !important;\n        span {\n          color: #616362 !important;\n          font-size: 13px !important;\n        }\n      }\n    }\n  }\n}\n.personal-account-item {\n  font-size: 13px !important;\n  font-family: \"Monsterrat 600\" !important;\n  box-shadow: none !important;\n}\n\n.table {\n  min-width: max-content;\n  width: 100%;\n  background: #fff;\n  border-radius: 15px;\n  tbody {\n    tr {\n      &:not(:last-child) {\n        border-bottom: 1px solid #eeeded;\n      }\n      // &:nth-child(even) {\n      //   background: #eeeded;\n      // }\n    }\n  }\n  .strong-tr {\n    td {\n      font-family: \"Monsterrat 600\";\n    }\n  }\n  th {\n    padding: 1rem 8px;\n    max-width: 225px;\n    min-width: 88px;\n    font-size: 13px;\n    text-align: left;\n    font-weight: 700;\n    position: relative;\n    color: #000;\n    z-index: 1;\n    &:first-child {\n      padding-left: 2rem;\n    }\n  }\n  td {\n    padding: 0.4rem 8px;\n    font-size: 13px;\n    font-weight: 600;\n    color: rgb(37, 37, 37);\n    &:first-child {\n      padding-left: 2rem;\n    }\n    &.bg-danger {\n      background: #f42020 !important;\n      color: #fff !important;\n      font-family: \"Monsterrat 500\" !important;\n      font-size: 15px !important;\n    }\n    &.bg-warning {\n      background: #ffb800 !important;\n      color: #fff !important;\n      font-family: \"Monsterrat 500\" !important;\n      font-size: 15px !important;\n    }\n  }\n  &.table-bordered {\n    thead {\n      tr {\n        position: relative;\n        border-bottom: 1.5px solid #eeeded;\n        padding: 4px;\n        &::after {\n          content: \"\";\n          border-radius: 15px;\n          position: absolute;\n          top: 5px;\n          left: 5px;\n          right: 5px;\n          bottom: 5px;\n          background: #eeeded;\n        }\n      }\n    }\n    tr {\n      th {\n        &::before {\n        }\n        &:not(:last-child) {\n          // border-right: 1px solid #8b8b8b;\n        }\n      }\n      td {\n        &:not(:last-child) {\n          // border-right: 1px solid #c8c8c8;\n        }\n      }\n    }\n  }\n  &.table-custom {\n    thead {\n      tr {\n        border-bottom: 1.5px solid #8b8b8b;\n      }\n    }\n    tr {\n      th {\n        position: relative;\n        padding: 1.25rem 12px;\n        &:not(:last-child)::before {\n          content: \"\";\n          position: absolute;\n          top: 50%;\n          right: 0;\n          transform: translateY(-50%);\n          height: 30px;\n          width: 1px;\n          background: #8b8b8b;\n        }\n      }\n    }\n  }\n}\n\n.main-buttons {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-left: auto;\n  margin-top: auto;\n}\n\n.modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 605px;\n  max-height: 90%;\n  transform: translate(-50%, -50%);\n  background: #fff;\n  border-radius: 10px;\n  overflow-y: auto;\n  &.transaction-modal {\n    width: 90%;\n    height: 90%;\n  }\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: rgba(255, 255, 255, 0.5);\n    border-radius: 8px;\n  }\n  @media (max-width: 767px) {\n    width: 98%;\n  }\n  .modal-body {\n    padding: 3.2rem;\n    position: relative;\n    overflow-y: auto;\n    @media (max-width: 767px) {\n      padding: 1.2rem 12px;\n    }\n    .modal-loading {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n      z-index: 1;\n      background: rgba(255, 255, 255, 0.5);\n      border-radius: 10px;\n    }\n  }\n}\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #ff6600;\n  border-radius: 10px 10px 0 0;\n  padding: 16px 20px;\n  .header-title {\n    font-family: \"Monsterrat 500\";\n    color: #fff;\n  }\n  button {\n    background: transparent;\n    transition: background 500ms;\n    &:hover {\n      background: rgb(255, 255, 255, 0.3);\n    }\n  }\n}\n.modal-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 20px;\n  gap: 12px;\n  .info-button {\n    display: flex;\n    align-items: center;\n    column-gap: 5px;\n    font-size: 13px;\n    border: 1px solid #00bf63;\n    border-radius: 5px;\n    padding: 8px 16px;\n    transition: background 500ms, color 500ms;\n    &:hover {\n      background: #00bf63;\n      color: #fff;\n    }\n  }\n}\n\n.modal-block {\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n  margin-bottom: 1rem;\n  label {\n    font-size: 13px;\n  }\n}\n\n.modal-item {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  padding: 12px 0;\n  border-top: 0.5px solid #8b8b8b;\n  font-size: 13px;\n  strong {\n    font-family: \"Monsterrat 600\" !important;\n    font-size: 13px;\n    text-align: right;\n  }\n}\n\n.stepper-indicators {\n  display: grid;\n  margin-bottom: 1rem;\n  .indicator {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    padding: 0.8rem 0;\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      left: 0;\n      width: 100%;\n      height: 2px;\n      background: #c8c8c8;\n      transform: translateY(-50%);\n    }\n    &.active {\n      &::before {\n        background: #2e8b57;\n      }\n      .indicator-count {\n        background: #2e8b57;\n      }\n      svg {\n        display: block;\n      }\n      .indicator-title {\n        color: #3e3e3e;\n      }\n    }\n    &.current {\n      &::before {\n        background: #ff6600;\n      }\n      .indicator-count {\n        background: #ff6600;\n      }\n    }\n    svg {\n      display: none;\n    }\n    .indicator-count {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 50px;\n      height: 50px;\n      border-radius: 50%;\n      background: #d9d9d9;\n      color: #fff;\n      font-size: 32px;\n      z-index: 1;\n      @media (max-width: 767px) {\n        width: 40px;\n        height: 40px;\n        font-size: 24px;\n      }\n    }\n  }\n  .indicator-title {\n    position: absolute;\n    top: 100%;\n    color: #858181;\n    font-size: 14px;\n    @media (max-width: 767px) {\n      font-size: 12px;\n      text-align: center;\n    }\n  }\n}\n\n.select-arrow {\n  overflow: hidden;\n  overflow: -moz-hidden-unscrollable;\n  background: url(\"../images/selectArrow.png\") no-repeat right white;\n  background-size: contain;\n  display: inline-block;\n  position: relative;\n  -webkit-appearance: none;\n  padding-right: 3rem;\n}\n\n.MuiTooltip-tooltip {\n  font-size: 16px !important;\n}\n.MuiCircularProgress-circle {\n  color: #1c1c84 !important;\n}\n.courier-select .MuiInputBase-input {\n  font-family: \"Monsterrat 400\" !important;\n  font-weight: 400 !important;\n  font-size: 14px !important;\n}\n\n.video-player {\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    border-radius: 4px;\n    background: #00000078;\n  }\n}\n\n.responsive-block {\n  @media (min-width: 1400px) and (max-width: 1600px) {\n    width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
